/* Copyright (c) 2020-present CloudIO Inc */

import { Item } from '../../registry/Component.type';

export const page: {
  root: Item<'Page'>;
  localDataStore: Item<'LocalDataStore'>;
  dataStoreReference: Item<'DataStoreReference'>;
  form: Item<'Form'>;
  multiField: Item<'MultiField'>;
  textField: Item<'TextField'>;
  icon: Item<'Icon'>;
  textField1: Item<'TextField'>;
  textField2: Item<'TextField'>;
} = {
  dataStoreReference: {
    children: ['form'],
    itemId: 'dataStoreReference',
    parent: 'root',
    props: {
      alias: 'alias',
    },
    type: 'DataStoreReference',
  },
  form: {
    children: ['textField1', 'multiField', 'textField2'],
    itemId: 'form',
    parent: 'dataStoreReference',
    props: {},
    type: 'Form',
  },
  icon: {
    children: [],
    itemId: 'icon',
    parent: 'multiField',
    props: {
      icon: {
        iconName: 'barcode-read',
        iconType: 'light',
      },
    },
    type: 'Icon',
  },
  localDataStore: {
    children: [],
    itemId: 'localDataStore',
    parent: 'root',
    props: {
      alias: 'alias',
      data: 'Name\nSteve Jobs',
      dataSource: 'ds',
    },
    type: 'LocalDataStore',
  },
  multiField: {
    children: ['textField', 'icon'],
    itemId: 'multiField',
    parent: 'form',
    props: {
      flex: {
        xs: 12,
      },
    },
    type: 'MultiField',
  },
  root: {
    children: ['localDataStore', 'dataStoreReference'],
    itemId: 'root',
    parent: 'root',
    props: {
      windowTitle: {
        type: 'text',
        value: 'CloudIO Help',
      },
    },
    type: 'Page',
  },
  textField: {
    children: [],
    itemId: 'textField',
    parent: 'multiField',
    props: {
      flex: {
        xs: true,
      },
      label: {
        type: 'text',
        value: 'Text Field inside Multi Field /w layout Fill',
      },
      viewAttribute: 'name',
    },
    type: 'TextField',
  },
  textField1: {
    children: [],
    itemId: 'textField1',
    parent: 'form',
    props: {
      flex: {
        xs: 12,
      },
      label: { type: 'text', value: 'Text Field /w layout 12' },
      viewAttribute: 'name',
    },
    type: 'TextField',
  },
  textField2: {
    children: [],
    itemId: 'textField2',
    parent: 'form',
    props: {
      flex: {
        xs: 12,
      },
      label: { type: 'text', value: 'Text Field /w layout 12' },
      viewAttribute: 'name',
    },
    type: 'TextField',
  },
};
